<template>
  <div>
    <div class="content-item">
      <div class="content-box">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="订单号"
              v-model="where.code"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="getLike">搜索</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 表格 -->
    <div class="content-item">
      <div class="content-box">
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          fit
        >
          <el-table-column label="目的地" width="120">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="收件时间" width="250">
            <template slot-scope="scope">
              {{ scope.row.date }} {{ scope.row.start }} - {{ scope.row.end }}
            </template>
          </el-table-column>
          <el-table-column label="订单号" width="180">
            <template slot-scope="scope">
              {{ scope.row.code }}
            </template>
          </el-table-column>
          <el-table-column label="联系人">
            <template slot-scope="scope">
              {{ scope.row.per_name }}
            </template>
          </el-table-column>
          <el-table-column label="电话" >
            <template slot-scope="scope">
              {{ scope.row.per_phone }}
            </template>
          </el-table-column>
          <el-table-column label="使用积分" align="center">
            <template slot-scope="scope">
              <el-link style="color: var(--color-next)">{{ scope.row.money }}€</el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status ? 'info' : ''">{{ !scope.row.status ? '正常' : '关闭' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.created_at | dateformat }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="" align="right" width="160">
            <template slot-scope="scope">
              <el-popconfirm
                v-if="!scope.row.status"
                title="确认取消通知取件订单？"
                @confirm="onCancel(scope.row.code)"
              >
                <el-button
                  size="mini"
                  type="primary"
                  slot="reference"
                >关闭通知</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-page">
          <div class="page-container">
            <el-pagination
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              background
              layout="total, prev, pager, next, jumper"
              @current-change="pageLoad"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { user_pickup, pickup_cancel } from '../api/api';

export default {
  name: 'Pickup',
  metaInfo(){
    return {
      title: '取件订单',
    }
  },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      pageSize: 0,
      currentPage: 0,

      where: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 列表
    getData() {
      this.listLoading = true
      user_pickup(this.currentPage, this.where).then(data => {
        this.total = data.total
        this.pageSize = data.per_page
        this.list = data.data
        this.listLoading = false
      })
    },
    // 分页
    pageLoad(page) {
      this.currentPage = page
      this.getData()
    },
    // 搜索
    getLike() {
      this.currentPage = 0
      this.getData()
    },
    onCancel(code) {
      pickup_cancel(code).then(res => {
        if(res.err) {
          return this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        this.getData()
        this.$message({
          message: '关闭成功，积分已返回',
          type: 'success'
        })
      })
    }
  },
}
</script>